// extracted by mini-css-extract-plugin
export default {"selectedSkills":"skills_select-module___selectedSkills___dbac8763"};